export default __webpack_public_path__ + "locales/ja-JP/FilesSettings.json?hash=5da13bd7c19ad10c5515216aca46f66a";